import React from 'react';
import { useTheme } from 'context/ThemeContext';

/** Matches the Controls selector (native <select>) */
export default function ThemeToggle() {
  const { theme, setTheme } = useTheme();
  const value = theme ?? 'system';

  return (
    <div className="relative">
      <select
        aria-label="Set Theme"
        className="appearance-none pr-9 pl-3 h-8 text-sm rounded-md border border-input
                  shadow-sm focus:outline-none focus:ring-2 focus:ring-ring max-w-full"
        style={{
          backgroundColor: 'hsl(var(--card))',
          color: 'hsl(var(--foreground))',
        }}
        value={value}
        onChange={(e) => setTheme(e.target.value)}
      >
        <option value="light">Light</option>
        <option value="dark">Dark</option>
        <option value="system">System</option>
      </select>

      <svg
        aria-hidden="true"
        className="pointer-events-none absolute right-2.5 top-1/2 -translate-y-1/2 h-4 w-4"
        style={{ color: 'hsl(var(--muted-foreground))' }}
        viewBox="0 0 20 20"
        fill="currentColor"
      >
        <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 10.2l3.71-2.97a.75.75 0 1 1 .94 1.17l-4.18 3.35a.75.75 0 0 1-.94 0L5.25 8.4a.75.75 0 0 1-.02-1.19z"/>
      </svg>
    </div>
  );
}
